import React, { Component } from 'react';
import { trans } from '../../../helpers/index';
import config from '../../../baseConfig/index';
import ApiManager from '../../../apiManager/index';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import Modal from '../../Fragments/Modal';
import {Link, Redirect, withRouter} from 'react-router-dom';
import ErrorModal from '../../Fragments/ErrorModal';

class InitFixInternetSteps extends Component {

    constructor( props ){
        super( props );

        this.state = {
            buttonDisabled: false,
            formResponse: '',
            showErrorModal: false
        };

        this.goToLoginPage = this.goToLoginPage.bind( this );

    }

    calcStepWidth(){

        return (100 / this.props.fixConfig.fixMaxStep) * this.props.fixConfig.fixStep

    }

    goToLoginPage(){
        this.props.setLoginAction( this.props.fixConfig.fixEmail );
        this.props.history.push(config.urlPrefix);
        return <Redirect to={config.urlPrefix} />;
    }

    emailExist( message ){

        return (
            <Modal
                title={trans(this.props.trans, 'auth.register.tel.modal.title')}
                description={message}
                agreeText={trans(this.props.trans, 'auth.register.tel.modal.agree')}
                agreeAction={this.goToLoginPage}
            />
        );

    }

    reSendData(){

        this.setState({ buttonDisabled: true });

        ApiManager.getRequest({}, '/csrf-token').then(( resolve ) => {
            this.props.setTokenAction( resolve.data );
            this.setState({ _token: resolve.data.data });
            this.sendData();
        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

    }

    sendData(){

        this.setState({ buttonDisabled: true });

        ApiManager.postRequest({
            login: this.props.fixConfig.fixLogin,
            ban_id: this.props.fixConfig.fixBanId,
            email: this.props.fixConfig.fixEmail,
            _token: this.props.csrf_token.data
        }, '/register/fixin/request').then(( resolve ) => {

            this.setState({
                buttonDisabled: false,
                formResponse: resolve.data
            });

            if ( resolve.data.hasOwnProperty('token') ) {
                this.props.updateParentState({
                    fixStep: 2,
                    fixToken: resolve.data.token
                });
            } else if ( resolve.data.status === 'CSRF_TOKEN_MISMATCH' ) {
                this.reSendData();
            }

        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.trans, 'error.modal.title' )}
                description={trans( this.props.trans, 'error.modal.description' )}
                action_text={trans( this.props.trans, 'error.modal.action_text' )}
            />
        );

    }

    render () {

        let errorBanIdClass = '',
            errorBanIdBox = '',
            errorLoginClass = '',
            errorLoginBox = '',
            errorEmailClass = '',
            errorEmailBox = '',
            errorBox = '',
            modal = '';

        if ( this.state.formResponse.status === 'EMAIL_EXISTS' ) {
            modal = this.emailExist(this.state.formResponse.message);
        }

        if ( this.state.formResponse !== '' ) {

            if ( this.state.formResponse.status === 'INVALID_DATA' ) {

                if ( this.state.formResponse.errors.hasOwnProperty('login') ) {
                    errorLoginClass = ' form-error';
                    errorLoginBox = <div className="form-error-text fs11">{this.state.formResponse.errors.login}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('ban_id') ) {
                    errorBanIdClass = ' form-error';
                    errorBanIdBox = <div className="form-error-text fs11">{this.state.formResponse.errors.ban_id}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('email') ) {
                    errorEmailClass = ' form-error';
                    errorEmailBox = <div className="form-error-text fs11">{this.state.formResponse.errors.email}</div>;
                }

            }

            if ( this.state.formResponse.status === 'ERROR' ) {

                errorBox = <FormMiddlewareError message={this.state.formResponse.message} trans={this.props.trans} />;

            }

        }

        return (
            <div className="form">

                <form action="#" method="post" onSubmit={(event) => {
                    this.sendData();
                    event.preventDefault();
                }}>

                    <div className="form__form-box form__form-box--with-space form-box">
                        <div className="form__sub-title db fs11">{this.props.fixConfig.fixStep} {trans(this.props.trans, 'auth.register.step.title')} {this.props.fixConfig.fixMaxStep}{trans(this.props.trans, 'auth.register.step' + this.props.fixConfig.fixMaxStep)}</div>
                        <div className="form__step-out">
                            <div className="form__step" style={{width: this.calcStepWidth() + '%'}}></div>
                        </div>
                    </div>
                    <div className={`form__form-box${errorLoginClass}`}>
                        <label className="form__label db fs11" htmlFor="login-name">{trans(this.props.trans, 'auth.register.fixin.label1')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field form__field--right-space fs13"
                                id="login-name"
                                type="text"
                                name="login-name"
                                placeholder={trans(this.props.trans, 'auth.register.fixin.placeholder1')}
                                onChange={( event ) => {
                                    this.props.updateParentState({
                                        fixLogin: event.target.value.trim().replace(/[^\d]/g, '')
                                    });
                                }}
                                value={this.props.fixConfig.fixLogin}
                            />
                            <div className="form__info-box pa">
                                <button className="form__info sprite" type="button"></button>
                                <div className="form__info-txt fs11 pa">{trans(this.props.trans, 'auth.register.fixin.hint1')}</div>
                            </div>
                        </div>
                        {errorLoginBox}
                    </div>
                    <div className={`form__form-box${errorBanIdClass}`}>
                        <label className="form__label db fs11" htmlFor="number">{trans(this.props.trans, 'auth.register.fixin.label2')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field form__field--right-space fs13"
                                id="number"
                                type="text"
                                name="number"
                                placeholder={trans(this.props.trans, 'auth.register.fixin.placeholder2')}
                                onChange={( event ) => {
                                    this.props.updateParentState({
                                        fixBanId: event.target.value.trim().replace(/[^\d]/g, '')
                                    });
                                }}
                                value={this.props.fixConfig.fixBanId}
                            />
                            <div className="form__info-box pa">
                                <button className="form__info sprite" type="button"></button>
                                <div className="form__info-txt fs11 pa">{trans(this.props.trans, 'auth.register.fixin.hint2')}</div>
                            </div>
                        </div>
                        {errorBanIdBox}
                    </div>

                    <div className={`form__form-box form__form-box--with-space${errorEmailClass}`}>
                        <label className="form__label db fs11" htmlFor="email">{trans(this.props.trans, 'auth.register.fixin.label3')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="email"
                                type="text"
                                name="email"
                                placeholder={trans(this.props.trans, 'auth.register.fixin.placeholder3')}
                                onChange={( event ) => {
                                    this.props.updateParentState({
                                        fixEmail: event.target.value.trim()
                                    });
                                }}
                                value={this.props.fixConfig.fixEmail}
                            />
                        </div>
                        {errorEmailBox}
                        <div className="form__details-txt fs11">{trans(this.props.trans, 'auth.register.fixin.code.note1')}</div>
                    </div>

                    {errorBox}

                    <button
                        className={`form__submit-btn btn btn--with-space btn--yellow fs17${this.state.buttonDisabled ? ' btn--loading' : ''}`}
                        type="submit"
                        disabled={this.state.buttonDisabled}
                    >{trans(this.props.trans, 'auth.register.fixin.button.title1')}</button>

                    <Link
                        className="form__submit-btn btn btn--white db fs17"
                        to={config.urlPrefix}
                    >{trans(this.props.trans, 'auth.register.fixin.button.cancel')}</Link>

                </form>

                {modal}
                {this.errorModal()}

            </div>
        );

    }

}

export default withRouter( InitFixInternetSteps );